export const recentCirculars = [
    {
        name: "Circular 202 SAR Verification Audit.pdf",
        path: "/assets/iqac/circulars/Circular 202 SAR Verification Audit.pdf",
        date: "2026-01-21"
    }
];

export const archivedCirculars = [
    {
        name: "ISO Surveillance audit schedule-19_04_2025.pdf",
        path: "/assets/iqac/circulars/archive/ISO Surveillance audit schedule-19_04_2025.pdf",
        date: "2025-04-19"
    },
    {
        name: "NBA Compliance Report 13.11.2024.pdf",
        path: "/assets/iqac/circulars/archive/NBA Compliance Report 13.11.2024.pdf",
        date: "2024-11-13"
    },
    {
        name: "NBA for Mca,Mba-13.11.2024.pdf",
        path: "/assets/iqac/circulars/archive/NBA for Mca,Mba-13.11.2024.pdf",
        date: "2024-11-13"
    }
];
